<template>
<div class="orderform">
  <div class="section is-medium">
    <div class="container" v-if="thankYouView === false">
      <h2 class="subtitle is-2 is-size-3-mobile has-text-centered">
        Noch
        <span class="has-text-weight-bold" v-if="activeStep === 2">1 Schritt</span>
        <span class="has-text-weight-bold" v-else-if="activeStep === 1">2 Schritte</span>
        <span class="has-text-weight-bold" v-else>3 Schritte</span>
        bis zum Honig
      </h2>
      <form>
        <b-steps :has-navigation="false" v-model="activeStep">
          <b-step-item label="Patenschaft">
            <step1
              @qmprice="pricestorage"
              @activeStep="stepsnav"
              @squaremeters="squaremeterstorage"
            />
          </b-step-item>
          <b-step-item label="Kontaktdaten">
            <step2
              @activeStep="stepsnav"
              @giftquestions="giftquestionstorage"
              @giftnames="giftnamestorage"
              @buyerfirsts="buyerfirststorage"
              @buyerlasts="buyerlaststorage"
              @StreetNumbers="StreetNumberstorage"
              @adressline2s="adressline2storage"
              @zips="zipstorage"
              @places="placestorage"
              @countrys="countrystorage"
              @buyerfirstsdelivery="buyerfirststoragedelivery"
              @buyerlastsdelivery="buyerlaststoragedelivery"
              @StreetNumbersdelivery="StreetNumberstoragedelivery"
              @adressline2sdelivery="adressline2storagedelivery"
              @zipsdelivery="zipstoragedelivery"
              @placesdelivery="placestoragedelivery"
              @countrysdelivery="countrystoragedelivery"
              @emails="emailstorage"
            />
          </b-step-item>
          <b-step-item label="Zahlung">
            <step3
              :pricebringer="price"
              :squaremeterbringer="squaremeter"
              :giftquestionbringer="giftquestion"
              :giftnamebringer="giftname"
              :buyerfirstbringer="buyerfirst"
              :buyerlastbringer="buyerlast"
              :StreetNumberbringer="StreetNumber"
              :adressline2bringer="adressline2"
              :zipbringer="zip"
              :placebringer="place"
              :countrybringer="country"
              :buyerfirstbringerdelivery="buyerfirstdelivery"
              :buyerlastbringerdelivery="buyerlastdelivery"
              :StreetNumberbringerdelivery="StreetNumberdelivery"
              :adressline2bringerdelivery="adressline2delivery"
              :zipbringerdelivery="zipdelivery"
              :placebringerdelivery="placedelivery"
              :countrybringerdelivery="countrydelivery"
              :emailbringer="email"
              @activeStep="stepsnav"
              @thankYouPage="thankYou"
            />
          </b-step-item>
        </b-steps>
      </form>
    </div>

    <div class="container has-text-centered" v-else>
      <h2 class="subtitle is-2 is-size-3-mobile thankyouborder">Vielen Dank für die Bestellung!</h2>
      <h3 class="subtitle is-5 is-size-6-mobile spacetop has-text-weight-bold">
        Du hast soeben {{ squaremeter }} Gläser Honig gekauft, die in der Blühsaison 2021 entstanden sind.
      </h3>
      <div class="coloumn column is-8 is-offset-2 spacetop is-size-6 is-size-7-mobile">
        <p>
          Unsere Versandabteilung nimmt die Arbeit auf und wird die Ware zeitnah zur Post bringen.
        </p>
        <div class="buttons spacetop is-centered">
          <b-button
            type="is-primary"
            size="is-large"
            class="is-right"
            @click="reloadpage"
            >Ich möchte zusätzlich eine Patenschaft für die Saison 2025 übernehmen.</b-button
          >
        </div>
        <p class="spacetop">Erzähl doch gerne auch anderen von uns:</p>
        </div>
        <div class="columns is-mobile is-multiline is-centered">
<div class="column is-narrow has-text-centered shareicon">
<a href="https://facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwilde-pracht.de" target="_blank" rel="noopener" aria-label="Die Wilde Pracht über Facebook teilen.">
<b-icon icon="facebook" size="is-large" type="is-info"></b-icon>
            </a>
          </div>
          <div class="column is-narrow has-text-centered shareicon">
<a :href="'https://twitter.com/intent/tweet/?text=Ich%20habe%20gerade%20Honig%20von%20https%3A%2F%2Fwilde-pracht.de%20gekauft.'" target="_blank" rel="noopener" aria-label="Die Wilde Pracht über Twitter teilen.">
<b-icon icon="twitter" size="is-large" type="is-info"></b-icon>
            </a>
          </div>
          <div class="column is-narrow has-text-centered shareicon">
<a :href="'https://reddit.com/submit/?url=https%3A%2F%2Fwilde-pracht.de&amp;resubmit=true&amp;title=Ich%20habe%20gerade%20Honig%20von%20https%3A%2F%2Fwilde-pracht.de%20gekauft.'" target="_blank" rel="noopener" aria-label="Die Wilde Pracht über Reddit teilen.">
<b-icon icon="reddit" size="is-large" type="is-info"></b-icon>
            </a>
          </div>
          <div class="column is-narrow has-text-centered shareicon">
<a :href="'https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A%2F%2Fwilde-pracht.de&amp;title=Ich%20habe%20gerade%20Honig%20von%20https%3A%2F%2Fwilde-pracht.de%20gekauft.&amp;summary=Ich%20habe%20gerade%20Honig%20von%20https%3A%2F%2Fwilde-pracht.de%20gekauft.&amp;source=https%3A%2F%2Fwilde-pracht.de'" target="_blank" rel="noopener" aria-label="Die Wilde Pracht über LinkedIn teilen.">
<b-icon icon="linkedin" size="is-large" type="is-info"></b-icon>
            </a>
          </div>
<div class="column is-narrow has-text-centered shareicon">
<a :href="'https://www.xing.com/app/user?op=share;url=https%3A%2F%2Fwilde-pracht.de;title=Ich%20habe%20gerade%20Honig%20von%20https%3A%2F%2Fwilde-pracht.de%20gekauft.'" target="_blank" rel="noopener" aria-label="Die Wilde Pracht über XING teilen.">
<b-icon icon="xing" size="is-large" type="is-info"></b-icon>
            </a>
          </div>

<div class="column is-narrow has-text-centered shareicon">
<a :href="'whatsapp://send?text=Ich%20habe%20gerade%20Honig%20von%20https%3A%2F%2Fwilde-pracht.de%20gekauft.%20https%3A%2F%2Fwilde-pracht.de'" target="_blank" rel="noopener" aria-label="Die Wilde Pracht über WhatsApp teilen.">
<b-icon icon="whatsapp" size="is-large" type="is-info"></b-icon>
            </a>
          </div>
<div class="column is-narrow has-text-centered shareicon spacebottom">
<a :href="'mailto:?subject=Ich%20bin%20Honigfan!&amp;body=Ich%20habe%20gerade%20Honig%20von%20https%3A%2F%2Fwilde-pracht.de%20gekauft.'" target="_self" rel="noopener" aria-label="Die Wilde Pracht über  E-Mail teilen.">
<b-icon icon="email" size="is-large" type="is-info"></b-icon>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



</template>

<script>
import Step1 from "@/components/OrderformHonig/Step1.vue";
import Step2 from "@/components/OrderformHonig/Step2.vue";
//import Step3 from "@/components/Orderform/Step3.vue";

export default {
  name: "OrderformHonig",
  components: {
    Step1,
    Step2,
    Step3: () => import("@/components/OrderformHonig/Step3.vue")
  },
  data() {
    return {
      price: "",
      pricebringer: 70,
      squaremeter: 2,
      activeStep: 0,
      thankYouView: false,
      giftquestion: "",
      giftname: "",
      buyerfirst: "",
      buyerlast: "",
      StreetNumber: "",
      adressline2: "",
      zip: "",
      place: "",
      country: "",
      buyerfirstdelivery: "",
      buyerlastdelivery: "",
      StreetNumberdelivery: "",
      adressline2delivery: "",
      zipdelivery: "",
      placedelivery: "",
      countrydelivery: "",
      email: ""
    };
  },
  methods: {
    pricestorage: function(value) {
      this.price = value;
    },
    squaremeterstorage: function(value) {
      this.squaremeter = value;
    },
    giftquestionstorage: function(value) {
      this.giftquestion = value;
    },
    giftnamestorage: function(value) {
      this.giftname = value;
    },
    buyerfirststorage: function(value) {
      this.buyerfirst = value;
    },
    buyerlaststorage: function(value) {
      this.buyerlast = value;
    },
    StreetNumberstorage: function(value) {
      this.StreetNumber = value;
    },
    adressline2storage: function(value) {
      this.adressline2 = value;
    },
    zipstorage: function(value) {
      this.zip = value;
    },
    placestorage: function(value) {
      this.place = value;
    },
    countrystorage: function(value) {
      this.country = value;
    },
    buyerfirststoragedelivery: function(value) {
      this.buyerfirstdelivery = value;
    },
    buyerlaststoragedelivery: function(value) {
      this.buyerlastdelivery = value;
    },
    StreetNumberstoragedelivery: function(value) {
      this.StreetNumberdelivery = value;
    },
    adressline2storagedelivery: function(value) {
      this.adressline2delivery = value;
    },
    zipstoragedelivery: function(value) {
      this.zipdelivery = value;
    },
    placestoragedelivery: function(value) {
      this.placedelivery = value;
    },
    countrystoragedelivery: function(value) {
      this.delivery = value;
    },
    emailstorage: function(value) {
      this.email = value;
    },
    stepsnav: function(value) {
      this.activeStep = value;
    },
    thankYou: function(value) {
      this.thankYouView = value;
    },
    reloadpage() {
      this.$router.push('/');
    }
  }
};
</script>

<style lang="scss">

.b-steps .steps .step-items .step-item.is-active .step-marker {
    background-color: $primary !important;
    border-color: $primary !important;
    color: $primary !important;
}

.b-steps .steps .step-items .step-item .step-marker {
      border-radius: 0% !important;
      height: 0.4rem !important;
      width: 96% !important;
      left: calc(2%) !important;
}

.step-details {
      margin-top: 0.2rem !important;
}

.step-details .step-title {
  display: none !important;
  font-size: 0.9rem !important;
  font-weight: 400 !important;
}

.thankyouborder {
  border-bottom: 0.4rem solid $primary !important;
  padding-bottom: 1.5rem !important;
}

.shareicon i:hover {
 color: $primary;
}
</style>
